
const fmtDate = {
    methods: {
        fmtDate(value,format = 'YYYY-MM-DD HH:mm') {
            if (!value) return '—'
            // підхоплює "YYYY-MM-DD HH:mm:ss" і ISO
            return moment(value).format(format);

            /*const str = String(value).replace(' ', 'T')
            const d = dayjs(str, ['YYYY-MM-DDTHH:mm:ss', 'YYYY-MM-DDTHH:mm'], true)
            return d.isValid() ? d.format(format) : value*/
        }
    }
}
export default fmtDate;
